module.exports = __webpack_public_path__ + "img/58.2ab88f48.jpg";